// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_RIu2j .dtr_XJ7qA {
  max-width: 320px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-width: 1px;
  border-color: rgba( 0, 0, 0, 0.25 );
}

.container_RIu2j .dtr_XJ7qA[data-value=true] {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.container_RIu2j .dtr_XJ7qA > :first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.clear_B5AL4.way_AYJer.more_wRBq0.specific_qminP {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-color: rgba( 0, 0, 0, 0.25 );
}

.createdAtPopup_BIQV8 {
  max-width: unset;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/actions/FilterByCreatedAt.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container .dtr {\n  max-width: 320px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-width: 1px;\n  border-color: rgba( 0, 0, 0, 0.25 );\n}\n\n.container .dtr[data-value=true] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.container .dtr > :first-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.clear.way.more.specific {\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-color: rgba( 0, 0, 0, 0.25 );\n}\n\n.createdAtPopup {\n  max-width: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_RIu2j`,
	"dtr": `dtr_XJ7qA`,
	"clear": `clear_B5AL4`,
	"way": `way_AYJer`,
	"more": `more_wRBq0`,
	"specific": `specific_qminP`,
	"createdAtPopup": `createdAtPopup_BIQV8`
};
export default ___CSS_LOADER_EXPORT___;
